// assets
import { IconKey } from '@tabler/icons';
import { IconClipboardList } from '@tabler/icons';
import { IconCalendarTime } from '@tabler/icons';
import { IconStack3 } from '@tabler/icons';
import { IconWindmill } from '@tabler/icons';
import { IconClock } from '@tabler/icons';
import { IconDatabase } from '@tabler/icons';
import { IconChartLine } from '@tabler/icons';

// constant
const icons = {
  IconKey,
  IconClipboardList,
  IconCalendarTime,
  IconStack3,
  IconWindmill,
  IconClock,
  IconDatabase,
  IconChartLine
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Infrastructure',
      type: 'item',
      url: '/',
      icon: icons.IconStack3,
      breadcrumbs: false
    },
    {
      id: 'locations',
      title: 'Locations',
      type: 'item',
      url: '/locations',
      icon: icons.IconClipboardList,
      breadcrumbs: false
    },
    {
      id: 'turbines',
      title: 'Turbines',
      type: 'item',
      url: '/turbines',
      icon: icons.IconWindmill,
      breadcrumbs: false
    },
    {
      id: 'forecasts',
      title: 'Forecasts',
      type: 'item',
      url: '/forecasts',
      icon: icons.IconClock,
      breadcrumbs: false
    },
    {
      id: 'sources',
      title: 'Sources',
      type: 'item',
      url: '/sources',
      icon: icons.IconDatabase,
      breadcrumbs: false
    },
    {
      id: 'comparison',
      title: 'Comparison',
      type: 'item',
      url: '/comparison',
      icon: icons.IconChartLine,
      breadcrumbs: false
    }
  ]
};

export default pages;
